import React, {useEffect, useState} from 'react';
import {castArray, isEmpty} from 'lodash';
import dayjs from 'dayjs';
import {getPageTriggers} from "../PageTriggers/triggerData";
import {evaluatePageTriggers} from "../PageTriggers/triggerLogic";
import {getSessionFacts} from "../Session/sessionFacts";
import DebugPageTriggers from "./DebugPageTriggers";
import {handleTriggerResults} from "../PageTriggers/triggerActions";

const isDev = (process.env.NODE_ENV == 'development');

const TIMEOUT = isDev ? 5_000 : 1000;

/**
 *
 * @param times array of [ sessionStart, renderedAt, idleTime, sessionAge ],
 *  via redux scrapyardSlice, from Springfield::Bakery::ControllerConcern
 * @param pageCount
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function PageTriggerInvoker({navigationSlice, sessionFacts, ...props}) {

  // time of day the page loaded
  const [appStartedAt, setAppStartedAt] = useState(dayjs())

  // present time of day, updated each second
  const [ticker, setTicker] = useState(null);

  const [triggers, setTriggers] = useState(null);
  const [triggerResults, setTriggerResults] = useState([]);
  // const [sessionFacts, setSessionFacts] = useState(getSessionFacts);

  /* Run once on startup */
  useEffect(() => {
    // fetch the page triggers on startup.
    // we pass in params so it can look for RESET
    getPageTriggers({params: sessionFacts?.currentParams})
      .then(data => {
        setTriggers(data);
        setTicker(new Date());
      })
      .catch(err => console.error(`error fetching pageTriggers: ${err}`));
  }, [typeof (sessionFacts)])

  // Evaluate page triggers every second.
  useEffect(() => {
    if (!ticker) return;

    const goAgain = () => {
      if (isEmpty(triggers))
        return;

      let now = new Date();
      setTicker(now); // set it up for next time

      // do NOT use any properties or state variables here, except triggers which
      // doesn't change often. Any props/state you see is from 1 second ago!
      let resultList = castArray(evaluatePageTriggers({triggers, now}));
      if (resultList) {
        setTriggerResults(resultList);
        handleTriggerResults({triggerResults: resultList, triggers, now});
      }
    }

    // Set a timeout for the next cycle. Do NOT use setInterval as it will
    // continue to use old dependencies, we want to pass in a fresh closure
    // every time.
    window.setTimeout(goAgain, TIMEOUT)
  }, [triggers, ticker]);

  return <DebugPageTriggers results={triggerResults} sessionFacts={sessionFacts} now={new Date()}/>
}


